var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#640917"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#4F72CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9783_91975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4322 13.1034V13.2034H21.5322H26.506C26.9686 13.2034 27.3453 13.58 27.3452 14.0427V15.1748C27.3452 15.5938 27.036 15.9415 26.6335 16.0033L26.556 16.0152L26.549 16.0933L26.2689 19.2519L26.2688 19.2519L26.2687 19.2539L26.2677 19.2642L26.2677 19.2643L25.2143 31.1393L25.2143 31.1395L25.214 31.1432C25.214 31.1434 25.214 31.1435 25.2139 31.1437C25.1711 31.5751 24.8123 31.9 24.3787 31.9H22.1053C21.9011 31.9 21.7355 31.7345 21.7355 31.5304C21.7355 31.3262 21.9011 31.1607 22.1052 31.1607H24.3786H24.4701L24.4782 31.0695L24.9422 25.8394L24.9543 25.7024L24.8203 25.7331L15.3275 27.9044L15.2425 27.9238L15.2502 28.0107L15.5216 31.0695L15.5297 31.1606H15.6212H17.8946C18.0988 31.1606 18.2643 31.3261 18.2643 31.5303C18.2643 31.7345 18.0988 31.9 17.8946 31.9H15.6212C15.1874 31.9 14.8286 31.5749 14.7859 31.1432L14.7856 31.1395L14.7856 31.1393L13.4514 16.0985L13.4442 16.018L13.364 16.0081C12.975 15.96 12.6547 15.6 12.6547 15.1748V14.0427C12.6547 13.58 13.0313 13.2034 13.494 13.2034H18.6816H18.7816V13.1034V9.68952C18.7816 8.81312 19.4946 8.1 20.3707 8.1H24.8525C25.3197 8.1 25.7 8.48029 25.7 8.94748V9.90308C25.7 10.3703 25.3197 10.7506 24.8525 10.7506H21.5403C21.4804 10.7506 21.4322 10.7996 21.4322 10.8587V13.1034ZM25.4844 18.9451L25.5553 18.9289L25.5617 18.8565L25.8042 16.123L25.8138 16.0142H25.7046H14.2954H14.1862L14.1958 16.123L14.6555 21.3054L14.6657 21.4196L14.7774 21.394L25.4844 18.9451ZM20.5929 13.2034H20.6929V13.1034V10.8587C20.6929 10.3915 21.0731 10.0112 21.5403 10.0112H24.8525C24.9127 10.0112 24.9607 9.96248 24.9607 9.90308V8.94748C24.9607 8.88752 24.9117 8.83933 24.8525 8.83933H20.3707C19.902 8.83933 19.521 9.22072 19.521 9.68952V13.1034V13.2034H19.621H20.5929ZM13.494 13.9427H13.394V14.0427V15.1748V15.2748H13.494H26.5059H26.6059V15.1748V14.0427V13.9427H26.5059H13.494ZM15.1666 27.0663L15.1767 27.1805L15.2885 27.1549L24.9522 24.9445L25.0231 24.9283L25.0295 24.8559L25.4745 19.84L25.4866 19.703L25.3526 19.7337L14.8166 22.1435L14.7316 22.1629L14.7393 22.2498L15.1666 27.0663Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 32.0019C20.2603 32.0019 20.4706 31.7916 20.4706 31.5322C20.4706 31.2728 20.2603 31.0625 20.0009 31.0625C19.7415 31.0625 19.5312 31.2728 19.5312 31.5322C19.5312 31.7916 19.7415 32.0019 20.0009 32.0019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9783_91975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaverage);
export default __webpack_public_path__ + "static/media/baverage.11f3707d602c04c9d1ccb6142fc4410a.svg";
export { ForwardRef as ReactComponent };